import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem("token"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return decryptedData;
};

export const getUsersAction = async (currentPage, searchValue, pageSize, status, byUser) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  let apiUrl = `/api/user?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}&status=${status}`;
  if (byUser) {
    apiUrl += `&byUser=${byUser}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createUserAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .post("/api/user/", data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const editUserAction = async (data, id) => {
  const authToken = getAuthToken();

  try {
    const response = await axios.put(`/api/user/${id}`, data, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("API ERROR:", error);


    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw {
        message: "Something went wrong. Please try again.",
      };
    }
  }
};
export const getUserDetailByIdAction = async (id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/user/user/${id}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteUserByIdAction = async (id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/user/user/${id}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateUserStatusAction = async (id, status) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const data = {
    isActive: status,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/user/update-user-status/${id}`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteMultipleUsersByIdAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/user/delete-multiple-user`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const verifyTermsAndConditionsAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/user/verifyTermsAndConditions`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const unblockUserAction = async (id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/user/unblock/${id}`, {}, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};